import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import 'firebase/auth';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-cabeceraadmin',
  templateUrl: './cabeceraadmin.component.html',
  styleUrls: ['./cabeceraadmin.component.scss']
})
export class CabeceraadminComponent implements OnInit {
  @Input() ampa: string;
  userId;
  private strings;

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {
    this.translate.get(['seguro']).subscribe((value) => {
         this.strings = value;
    })
    this.userId = localStorage.getItem('userId');
    if(!this.userId){
      this.router.navigate(['']);
    }
  }

  ngOnInit() {
  }

  logout(){
    var r = confirm(this.strings['seguro'])
    if(r === true){
      firebase.auth().signOut()
      .then(()=>{
        localStorage.removeItem('userId');
        this.router.navigate(['']);
      })
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/cabeceraadmin/cabeceraadmin.component.ts